export default {"src":"/_next/static/media/icon-agricultural.9e1a8828.svg","height":27,"width":29,"blurWidth":0,"blurHeight":0};